/**
 * Take care importing code here! This is injected into every app as an individual script tag.
 */
import { getHostname, getTrellisTestDayId, isTrellisTestDay, isWebdriver, setupLocalStorageForTestDay } from './trellis-test-day';
const QA_APP_REGEXP = /(app|local)(-[a-z]+[0-9])?\.hubspotqa\.com/;
const VALID_THEMES = new Set(['trellis-light', 'canvas-light']);
export const DEFAULT_THEME = 'canvas-light';
const COOKIE_THEME_KEY = 'hubspot-theme';
const DATASET_THEME_KEY = 'hubspotTheme';
const LOCAL_STORAGE_THEME_KEY = 'hubspot-theme';
function getCookie(name) {
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? match[2] : null;
}
export function getThemeSetting() {
  try {
    // get theme setting from hubspot-theme cookie with higher priority than localStorage
    const themeCookie = getCookie(COOKIE_THEME_KEY);
    const localStorageTheme = localStorage.getItem(LOCAL_STORAGE_THEME_KEY);
    const themeSetting = themeCookie || localStorageTheme;
    if (themeSetting && VALID_THEMES.has(themeSetting)) {
      return themeSetting;
    }
  } catch (e) {
    // do nothing
  }
  return null;
}
export function isHubspotQA() {
  const hostname = getHostname();
  return QA_APP_REGEXP.test(hostname);
}

/**
 * This function is run in the `hubspot-theme` file which is loaded in the <head /> of apps.
 * This is used to synchronize a users theme setting (cookie/local storage) with the data-hubspot-theme
 * `<html />` tag of the app, which is what ThemeProvider uses to derive the theme, and what the CSS
 * uses to select the correct values for the CSS variables. This code runs very early on the page,
 * and is inlined into every app.
 */
export function setupTheme() {
  try {
    const isQa = isHubspotQA();
    let defaultTheme = DEFAULT_THEME;

    // Trellis Test Days are only applied in QA.
    if (isQa) {
      const now = new Date();
      const dateInput = {
        day: now.getUTCDay(),
        hour: now.getUTCHours(),
        now: now.getTime()
      };

      // We don't want to apply TTD code to ATs or unit tests
      // ATs will have VR snapshots that rely on Canvas Light theme
      // Unit tests might be relying on style-specific behaviour for their selectors.
      const isTestDay = isTrellisTestDay(dateInput) && !isWebdriver();
      if (isTestDay) {
        const testDayId = getTrellisTestDayId(dateInput);
        setupLocalStorageForTestDay(String(testDayId));
        defaultTheme = 'trellis-light';
      }
    }
    const themeSetting = getThemeSetting() || defaultTheme;
    document.documentElement.dataset[DATASET_THEME_KEY] = themeSetting;
  } catch (_unused) {
    // do nothing
  }
}